<template>
  <v-app id="app">   
    <DrawerSkills v-if="this.$route.name === 'Core'" />
    <!-- <v-content class="bg-custom-color"> -->
    <router-view></router-view>

    <notifications position="bottom right" type="warn" />
    <!-- style="margin-left:10px;margin-bottom:35px" -->
    <!-- </v-content> -->
  </v-app>
</template>

<script>
import DrawerSkills from "@/components/DrawerSkills.vue";

//start my code 


//finish my code

export default {
  name: "App",
  components: {
    DrawerSkills
  },
};
</script>

<style lang="scss">
@import "./sass/custom-variables.scss";
html {
  overflow-y: scroll !important;
  background: $egsy-background;
}

/*
 *  STYLE 4
 */

*::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  /* background-color: #f5f5f5; */
}

*::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
